import { createContext } from 'react';

const defaultState = {
  enableMoreDetail: false,
  enableQualityCheck: false,
};

export const AnswerConfigContext = createContext(defaultState);
